import { Tab, TabProps, Text } from '@chakra-ui/react';

interface SearchListTabProps extends TabProps {
  title: string;
}

export const SearchListTab = ({ title, ...props }: SearchListTabProps) => {
  return (
    <Tab
      fontWeight="normal"
      _selected={{
        color: 'black',
        bg: 'transparent',
        fontWeight: 'medium',
        borderBottomWidth: '2px',
        borderBottomColor: 'black',
      }}
      px={{ mobile: '3', desktop: '6' }}
      zIndex="1"
      flex="1"
      {...props}
    >
      <Text size="sm">{title}</Text>
    </Tab>
  );
};
